import type { EstadoTampaOficina } from '../../dominio/didatico/oficinaPortaMalas'
import { ABERTURA_RAD_TAMPA, eixoDaTampaTraseira, type PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { deArray, girarEmTorno, paraArray, somar, subtrair, vetor } from '../../dominio/geometria/vetor3'

export { ABERTURA_RAD_TAMPA }

export interface QuadroDaTampa {
  origem: [number, number, number]
  giroX: number
  deslocamentoX: number
}

export function quadroDaTampa(perfil: PerfilVeiculo, estado?: EstadoTampaOficina): QuadroDaTampa {
  return {
    origem: [...eixoDaTampaTraseira(perfil)],
    giroX: ABERTURA_RAD_TAMPA * (estado?.abertura ?? 0),
    deslocamentoX: estado?.chapa === 'deformada' ? 0.06 : 0,
  }
}

export function posicaoNoQuadroDaTampa(
  quadro: QuadroDaTampa,
  canonica: [number, number, number],
): [number, number, number] {
  const origem = deArray(quadro.origem)
  const deslocada = somar(deArray(canonica), vetor(quadro.deslocamentoX, 0, 0))
  return paraArray(somar(girarEmTorno(subtrair(deslocada, origem), vetor(1, 0, 0), quadro.giroX), origem))
}

export function canonicaDoQuadroDaTampa(
  quadro: QuadroDaTampa,
  ponto: [number, number, number],
): [number, number, number] {
  const origem = deArray(quadro.origem)
  const semGiro = somar(girarEmTorno(subtrair(deArray(ponto), origem), vetor(1, 0, 0), -quadro.giroX), origem)
  return paraArray(subtrair(semGiro, vetor(quadro.deslocamentoX, 0, 0)))
}
